"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerComponent = exports.ROUTES = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var department_selector_1 = require("../../modules/department.selector/department.selector");
var omni_search_1 = require("../../modules/omni.search/omni.search");
var change_settings_1 = require("../../modules/user/change.settings");
var page_1 = require("../../page/page");
var page_layout_1 = require("../../page/page.layout");
var services_1 = require("../../services");
var userDisplayName_1 = require("../../util/userDisplayName");
var image_button_1 = require("../button/image.button");
var icons_1 = require("../icon/icons");
var menu_1 = require("../menu/menu");
var menu_item_1 = require("../menu/menu.item");
var mithril_component_1 = require("../mithril.component");
var modal_service_1 = require("../modal/modal.service");
var theme_1 = require("../theme");
var banner_style_1 = require("./banner.style");
exports.ROUTES = {
    FORM_LIST: function () { return services_1.Services.Route.go(page_1.IkePageName.formList); },
    ORG_SEARCH: function () { return services_1.Services.Route.go(page_1.IkePageName.orgSearch); },
    ACCOUNTS: function () { return services_1.Services.Route.go(page_1.IkePageName.accountList); },
    LOGOUT: function () { return services_1.Services.Route.go(page_1.IkePageName.logout); }
};
var BannerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(BannerComponent, _super);
    function BannerComponent() {
        var _this = _super.call(this) || this;
        _this.name = 'Banner';
        _this.departmentSelector = new department_selector_1.DepartmentSelector();
        _this.changeSettings = new change_settings_1.ChangeSettingsComponent();
        _this.omniSearch = new omni_search_1.OmniSearch();
        _this.menu = new menu_1.MenuComponent({
            items: function () { return _this.viewMenuItems; }
        });
        _this.helpmenu = new menu_1.MenuComponent({
            items: function () { return _this.viewHelpMenuItems; }
        });
        return _this;
    }
    Object.defineProperty(BannerComponent.prototype, "nodes", {
        get: function () {
            if (!services_1.Services.User.hasUser) {
                services_1.Services.User.logout();
                return null;
            }
            document.title = (0, i18n_1.Translate)(services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IKE_OFFICE_PRO) ? i18n_1.T.IKE_OFFICE_PRO : i18n_1.T.IKE_OFFICE);
            var asset = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IKE_OFFICE_PRO) ? (0, theme_1.assetPath)('/images/Logo-IKE-Office-Pro.svg') : (0, theme_1.assetPath)('/images/Logo-IKE-Office.svg');
            var officeImg = (0, mithril_1.m)('img', { src: asset, alt: 'IKE Office Logo', style: 'height: 35px; margin-right: 5px;' });
            var isMap = services_1.Services.Route.active.config.name === page_1.IkePageName.map;
            return [
                (0, mithril_1.m)('header', { className: banner_style_1.CSS.header.container }, [
                    (0, mithril_1.m)('div', { className: banner_style_1.CSS.header.row }, [
                        this.viewDrawerButton,
                        (0, mithril_1.m)('div', { className: banner_style_1.CSS.header.section }, [
                            (0, mithril_1.m)('span', { className: banner_style_1.MDL.title }, officeImg),
                            this.departmentSelector.view()
                        ]),
                        isMap ? this.omniSearch.view() : null,
                        (0, mithril_1.m)('div', { className: "".concat(banner_style_1.CSS.header.section, " ").concat(banner_style_1.CSS.header.sectionRight) }, [
                            this.helpmenu.view(),
                            image_button_1.ImageButton.view(icons_1.MaterialIcon.HELP_OUTLINE, { onclick: this.helpmenu.show, title: i18n_1.T.HELP_MENU }),
                            image_button_1.ImageButton.view(icons_1.MaterialIcon.PERSON, { onclick: this.menu.show, title: i18n_1.T.USER_MENU_SETTINGS }),
                            this.menu.view()
                        ])
                    ])
                ])
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "viewFormIcon", {
        get: function () {
            return image_button_1.ImageButton.view(icons_1.MaterialIcon.CONTENT_PASTE, { onclick: exports.ROUTES.FORM_LIST, title: i18n_1.T.USER_MENU_FORM });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "viewSearchIcon", {
        get: function () {
            if (!services_1.Services.Token.has(core_api_1.IkeToken.ORG_SEARCH_PAGE) && !services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
                return null;
            }
            return image_button_1.ImageButton.view(icons_1.MaterialIcon.ORG_SEARCH, { onclick: exports.ROUTES.ORG_SEARCH, title: i18n_1.T.ORG_SEARCH });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "viewDrawerButton", {
        get: function () {
            return image_button_1.ImageButton.view(icons_1.MaterialIcon.MENU, { onclick: function () { return page_layout_1.PageLayoutState.nav.setVisible(true); }, title: 'menu' });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "viewHelpMenuItems", {
        get: function () {
            return [
                {
                    view: this.viewHelpCard,
                    component: true,
                    disabled: true
                }, {
                    view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.SUBMIT_SUPPORT_REQUEST)),
                    action: function () { return window.open('https://support.ikegps.com/hc/en-us/requests/new?ticket_form_id=5786678993677'); },
                    visible: true
                }, {
                    view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.SUPPORT_PORTAL)),
                    action: function () { return window.open('https://support.ikegps.com'); },
                    visible: true
                }, {
                    view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.RELEASE_NOTES)),
                    action: function () { return window.open('https://ikegps.zendesk.com/hc/en-us/categories/16992245574541-Release-Notes'); },
                    visible: true
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "viewMenuItems", {
        get: function () {
            var _this = this;
            return [
                {
                    view: this.viewUserCard,
                    component: true,
                    disabled: true
                }, {
                    view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.USER_MENU_ACCOUNTS)),
                    action: exports.ROUTES.ACCOUNTS,
                    visible: services_1.Services.Token.has(core_api_1.IkeToken.COMPANY_ACCOUNTS)
                }, {
                    view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.USER_MENU_SETTINGS)),
                    action: function () { return _this.openChangeSettings(); }
                }, {
                    view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.USER_MENU_CHANGE_PASSWORD)),
                    action: function () { return _this.openChangePassword(); },
                    divider: true
                }, {
                    view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.USER_MENU_LOGOUT)),
                    action: exports.ROUTES.LOGOUT
                }
            ].filter(Boolean);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "viewUserCard", {
        get: function () {
            var currentUser = services_1.Services.User.current;
            if (currentUser == null) {
                return null;
            }
            var displayName = (0, userDisplayName_1.userDisplayName)(currentUser);
            return (0, mithril_1.m)('div', { className: banner_style_1.CSS.user.card, onclick: function (e) { return e.stopPropagation(); } }, [
                (0, mithril_1.m)('div', { className: banner_style_1.CSS.user.name }, displayName),
                displayName !== currentUser.username ? (0, mithril_1.m)('div', { className: banner_style_1.CSS.user.email }, currentUser.username) : null
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "viewHelpCard", {
        get: function () {
            return (0, mithril_1.m)('div', { className: banner_style_1.CSS.user.card, onclick: function (e) { return e.stopPropagation(); } }, [
                (0, mithril_1.m)('div', { className: banner_style_1.CSS.user.name }, (0, i18n_1.Translate)(i18n_1.T.HELP_MENU))
            ]);
        },
        enumerable: false,
        configurable: true
    });
    BannerComponent.prototype.openChangeSettings = function () {
        this.changeSettings.open();
    };
    BannerComponent.prototype.openChangePassword = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, okResult;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, modal_service_1.ModalService.open({
                            title: (0, i18n_1.Translate)(i18n_1.T.PASSWORD_CHANGE_PASSWORD),
                            content: (0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.PASSWORD_CHANGE_PASSWORD_DETAIL)),
                            hasCancel: true,
                            okName: i18n_1.T.SEND
                        })];
                    case 1:
                        result = _a.sent();
                        if (!result.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, services_1.Services.SSO.resetPassword()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, modal_service_1.ModalService.open({
                                title: (0, i18n_1.Translate)(i18n_1.T.PASSWORD_CHANGE_PASSWORD),
                                content: (0, i18n_1.Translate)(i18n_1.T.PASSWORD_RESET_EMAIL_SENT),
                                okName: i18n_1.T.LOGOUT
                            })];
                    case 3:
                        okResult = _a.sent();
                        if (okResult.ok) {
                            services_1.Services.SSO.logout(true);
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], BannerComponent.prototype, "nodes", null);
    return BannerComponent;
}(mithril_component_1.IMithrilComponent));
exports.BannerComponent = BannerComponent;
//# sourceMappingURL=banner.js.map